import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";

export const notesTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Belgrade";
export const notesChanged = () => window.dispatchEvent(new Event("notes-changed"));

// Bind every request to the session that opened this view, including mutations.
export function notesApi(token) {
  const config = { headers: { Authorization: `Bearer ${token}` }, timeout: 20000 };
  const url = `${ApiLink.API_URL}notes`;
  return {
    list: (params, signal) => axios.get(url, { ...config, signal, params: { ...params, timeZone: notesTimeZone() } }).then(r => r.data),
    get: (id, signal) => axios.get(`${url}/${id}`, { ...config, signal, params: { timeZone: notesTimeZone() } }).then(r => r.data),
    notifications: signal => axios.get(`${url}/notifications`, { ...config, signal, params: { timeZone: notesTimeZone() } }).then(r => r.data),
    save: (id, payload) => id ? axios.put(`${url}/${id}`, payload, config) : axios.post(url, payload, config),
    change: (id, action, payload) => action === "delete" ? axios.delete(`${url}/${id}`, config)
      : axios.patch(`${url}/${id}/${action}`, payload || {}, config),
  };
}
